var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"be-payment-card"},[_c('div',{staticClass:"be-payment-card__icon"},[_c('img',{attrs:{"src":_vm.paymentBrand(_vm.brand).logo,"alt":_vm.paymentBrand(_vm.brand).alt}})]),_c('span',{staticClass:"be-payment-card__number"},[_vm._v("**** **** **** "+_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }